import { Injectable, EventEmitter } from '@angular/core';
import { ShopListInterface } from '../interfaces/shop-list-interface';

@Injectable({
  providedIn: 'root'
})
export class ShopDetailService {
  // used to track when a shop got selected to display more information
  readonly displayingShop = new EventEmitter<ShopListInterface>();

  // used to track when a shop got selected to display products (product page)
  readonly goToProduct = new EventEmitter<ShopListInterface>();

  // used to track when a shop got selected to be displayed on a map
  readonly showOnMap = new EventEmitter<ShopListInterface>();
}
